package pl.decks.personal.components.widgets.timeline

enum class Month(val shortLabel: String) {
    JANUARY("Jan"),
    FEBRUARY("Feb"),
    MARCH("Mar"),
    APRIL("Apr"),
    MAY("May"),
    JUNE("Jun"),
    JULY("Jul"),
    AUGUST("Aug"),
    SEPTEMBER("Sep"),
    OCTOBER("Oct"),
    NOVEMBER("Nov"),
    DECEMBER("Dec"),
    ;

    companion object {
        operator fun invoke(monthOfYear: Int) = entries.first { it.numbered == monthOfYear }
    }

    val numbered = this.ordinal + 1
}
